import axios from 'axios';
import composeP from 'ramda/src/composeP';

const serviceCaller = (
    httpClient,
    serviceUrl,
    serviceRequest,
    serviceProxy,
    requestData,
) => {
    const request = serviceRequest(requestData);
    request.url = serviceUrl;

    const extractData = response => response.data;

    const callService = composeP(
        serviceProxy,
        extractData,
        httpClient,
    );

    return callService(request);
};

const callService = serviceCaller.bind(null, axios);

export {
    serviceCaller,
    callService as default,
};
